import { DateRange } from 'bold-ui'
import { max as maxDate, subMonths } from 'date-fns'
import {
  AtendimentosFinalizadosInput,
  AtendimentosFinalizadosQuery,
  OrigemDadoEnum,
  StatusAssinatura,
} from 'graphql/types.generated'
import { convertDateRangeToLocalDateRange } from 'util/date/dateRange'
import { toDate } from 'util/date/formatDate'
import { HistoricoDetalhesModel } from 'view/atendimentos/detail/historico/model/model-historico'

type AtendimentoFinalizadoItem = NonNullable<
  NonNullable<AtendimentosFinalizadosQuery['atendimentosFinalizados']>['content'][number]
>

import {
  AssinaturaEletronicaAtendTableFilterModel,
  AssinaturaEletronicaAtendTableRowModel,
  CriterioExibicaoAtendimento,
  MESES_PERIODO_ASSINATURA_DIGITAL,
} from './model-assinaturaEletronicaAtend'

export function getDefaultPeriodoAssinaturaDigital(serverNow: Date, dataAtivacao?: LocalDate | null): DateRange {
  const inicioUltimosTresMeses = subMonths(serverNow, MESES_PERIODO_ASSINATURA_DIGITAL)
  const dataAtivacaoDate = toDate(dataAtivacao ?? undefined)
  const startDate = dataAtivacaoDate ? maxDate([inicioUltimosTresMeses, dataAtivacaoDate]) : inicioUltimosTresMeses

  return { startDate, endDate: serverNow }
}

export const convertAssinaturaFilterModelToInput = (
  form: AssinaturaEletronicaAtendTableFilterModel
): AtendimentosFinalizadosInput =>
  form && {
    hasAssinatura:
      form.criterioExibicao === CriterioExibicaoAtendimento.ATENDIMENTOS_COM_ASSINATURA
        ? true
        : form.criterioExibicao === CriterioExibicaoAtendimento.ATENDIMENTOS_SEM_ASSINATURA
        ? false
        : undefined,
    periodo: convertDateRangeToLocalDateRange(form.periodo),
    pageParams: form.pageParams,
  }

export const convertAssinaturaModelToHistoricoModel = (
  detalhesAtendimento: AssinaturaEletronicaAtendTableRowModel
): HistoricoDetalhesModel => ({
  origemAtendimento: OrigemDadoEnum.PEC,
  tipoAtendProf: detalhesAtendimento.tipoAtendimento,
  codigoUnicoRegistro: detalhesAtendimento.codigoUnicoRegistro,
  cpfCnsCidadao: detalhesAtendimento.cidadao?.cpf ?? detalhesAtendimento.cidadao?.cns,
  isAtendRecente: detalhesAtendimento.isAtendimentoRecente,
  idAtendRecente: detalhesAtendimento.id,
  fichasConcatenadas: undefined,
  dataAtendimento: detalhesAtendimento.dataRegistro,
  hasObservacao: detalhesAtendimento.hasObservacao,
})

export const convertAtendProfToAssinaturaEletronicaRowModel = (
  atendProf: AtendimentoFinalizadoItem
): AssinaturaEletronicaAtendTableRowModel => ({
  id: atendProf.id,
  dataRegistro: atendProf.finalizadoEm,
  tipoAtendimento: atendProf.tipo,
  codigoUnicoRegistro: atendProf.codigoUnicoRegistro,
  isAtendimentoRecente: atendProf.isAtendRecente,
  hasObservacao: !!atendProf.atendimentoProfissionalObservacao,
  cidadao: atendProf.atendimento
    ? {
        nomeSocial: atendProf.atendimento.cidadao.nomeSocial ?? undefined,
        nome: atendProf.atendimento.cidadao.nome ?? undefined,
        cpf: atendProf.atendimento.cidadao.cpf ?? undefined,
        cns: atendProf.atendimento.cidadao.cns ?? undefined,
        dataNascimento: atendProf.atendimento.cidadao.dataNascimento ?? undefined,
      }
    : undefined,
  horarioAssinatura: atendProf.assinaturaEletronicaAtend?.dtAssinatura,
  statusAssinatura: atendProf.assinaturaEletronicaAtend?.status ?? undefined,
  isAtendimentoAssinado: atendProf.assinaturaEletronicaAtend?.status === StatusAssinatura.ASSINADO,
  isObservacaoNaoFinalizada:
    atendProf.atendimentoProfissionalObservacao != null &&
    !atendProf.atendimentoProfissionalObservacao.atendimentoObservacao.isFinalizado,
})
